export const copyClipboard = (text: string, copied: () => void, error: (err: Error) => void) => {
    if (typeof text !== 'string') {
        return;
    }
    if (!navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') {
        return;
    }
    return navigator.clipboard.writeText(text).then(
        () => {
            copied();
        },
        (err) => {
            error(err);
        },
    );
};
